import {
  Dialog,
  DialogContent,
  DialogTitle,
} from "@imminently/react/ui/core/dialog";
import { Text } from "@imminently/react/ui/core/text";
import { PropsWithChildren } from "react";

import { PatientEncounter } from "@/resources/types";
import { PatientCard } from "./PatientCard";
import { Stack } from "@mui/material";

const styles = {
  modalContent: {
    display: "flex",
    flexDirection: "row",
    gap: 2,
    width: "56rem",
    paddingBottom: 4,
    paddingTop: 2,
  },
};

type PatientCardModalProps = PropsWithChildren & {
  title: string;
  encounter: PatientEncounter;
  onClose: () => void;
  gap?: number;
};

const PatientCardModal = (props: PatientCardModalProps) => {
  const { title, encounter, children, onClose, gap = 1 } = props;

  return (
    <Dialog open onClose={onClose} maxWidth="md">
      <DialogTitle>
        <Text variant="h4">{title}</Text>
      </DialogTitle>

      <DialogContent sx={styles.modalContent}>
        <PatientCard encounter={encounter} />

        <Stack flex={1} gap={gap}>
          {children}
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default PatientCardModal;
